export default __webpack_public_path__ + "static/media/loader.19116e82.gif";